import PubNub, { MessageEvent } from 'pubnub'
import { FC, PropsWithChildren, useEffect } from 'react'
import { AppHTTPService } from '../api/http-service'
import { useActiveEnvironment } from '../hooks/useEnvironments'
import { EventStream } from '../api/events'

export const EventStreamProvider: FC<PropsWithChildren> = ({ children }) => {
  const { environment } = useActiveEnvironment()

  useEffect(() => {
    let pubnubInstance: PubNub | undefined

    const handler = {
      message(event: MessageEvent) {
        try {
          const msg = JSON.parse(event?.message || '{}')
          EventStream.next(msg)
        } catch (e) {
          console.warn('PubNub Listener Error\n', e)
        }
      },
    }
    if (environment) {
      initializePubnubClient(environment.id).then((p) => {
        pubnubInstance = p
        pubnubInstance?.addListener(handler)
      })
    }

    return () => {
      pubnubInstance?.removeListener(handler)
      pubnubInstance?.unsubscribeAll()
    }
  }, [environment?.id])

  return <>{children}</>
}

async function initializePubnubClient(environmentId: string): Promise<PubNub | undefined> {
  return AppHTTPService.client.events
    .getEventToken({ scope: environmentId })
    .then(({ data }) => {
      if (data) {
        const pubnub = new PubNub({
          subscribeKey: data.subscribeKey!,
          uuid: data.accountId!,
        })
        pubnub.setToken(data.token!)
        pubnub.subscribe({ channels: [`environment.${environmentId}`] })
        return pubnub
      }
      console.warn('Unable to get event token')
      return undefined
    })
    .catch((e) => {
      console.warn('Unable to get event token: ', e)
      return undefined
    })
}
